import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useApplicationPermissions } from '../../../../state/hooks/ApplicationHooks';

export const useActionsToolbar = () => {
  const { t } = useTranslation();

  const permissions = useApplicationPermissions();
  const datastorePermissionsLabels = useMemo(() => {
    const labels = [];
    const permissionsNames = Object.values(permissions.dataset);

    permissionsNames.forEach((permissionName) =>
      labels.push({
        value: permissionName,
        label: t(`commoncomponents.datastore.dialogs.share.datasetPermissions.${permissionName}`, permissionName),
      })
    );
    return labels;
  }, [permissions.dataset, t]);

  return { datastorePermissionsLabels };
};
